export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_FORMAT_REVERSE = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const FULL_DATE_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const FULL_DATE_FORMAT_2 = `${DATE_FORMAT}, ${TIME_FORMAT}`;
export const DATE_FORMAT_LONG = 'MMMM DD, YYYY';
export const REPORT_DATE_FORMAT = 'DD/MM/YYYY';
export const FULL_DATE_WITHOUT_YEAR_FORMAT = `DD MMM ${TIME_FORMAT}`;
